import withFormResults from 'components/shared/withFormResults'

const withRegistrationCheckoutFormResults = withFormResults({
  mutation: 'checkOut',
  field: 'transaction',
  redirect: '/complete',
  successMessage: 'Registration complete!',

  // see also app/javascript/containers/account/CheckoutFormContainer/withFormResults.js
  onSuccess: data => {
    const purchase = data.checkOut.transaction?.gtmPurchase

    if (window.dataLayer && purchase) {
      window.dataLayer.push(purchase)
      window.dataLayer.push({ event: 'register.completed' })
    }
  }
})

export default withRegistrationCheckoutFormResults
